(function($, Drupal) {
  'use strict';

  /*inicializamos scripts para que cargen en cuando finalice la carga del DOM */
  $(document).ready(function() {


    /**
     * Grids intercambio de imágenes
     */

    $('.studies__grid__item')
      .on("mouseenter", function() {

        // Localizamos la imagen de la columna sobre la que estamos
        let target = $(this).data("pic-target");
        let last = '.' + $('.studies-background-wrapper picture').last().attr('class');

        if(target != last){
          $(target).hide();
          $(target).appendTo('.studies-background-wrapper');
          $(target).fadeIn();
        }
        window.bLazy.revalidate();
      });

    /* Inicialización de ekko-lightbox */
    $(document).on('click', '[data-toggle="lightbox"]', function(event) {
      event.preventDefault();
      $(this).ekkoLightbox({
        alwaysShowClose: true
      });
    });

    // Activación del popover en la cabecera versión móvil
    $('.user-access-link').popover({
      html: true,
      trigger: 'focus',
      template: '<div class="popover popover-custom" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
    });

    // Interceptamos eventos del megamenu para evitar comportamientos erroneos
    // Al hacer click en un tab, añadimos al dropdown una clase "no cerrar".
    // justo antes de que se cierre el dropdown comprobamos si tiene la clase para
    // evitar el cierre o permitirlo.

    $('.dropdown-menu').on('click', function(e){
      $(this).closest('.dropdown').addClass('dontClose');
    });

    $('.megamenu').on('shown.bs.dropdown', function(e) {
      $('header').addClass('megamenu-open');
    });

    $('.megamenu').on('hidden.bs.dropdown', function(e) {
      $('header').removeClass('megamenu-open');
    });

    $('#megamenu-estudios').on('show.bs.dropdown', function(e) {
      $(this).find('.dropdown-menu').first().stop(true, true).slideDown();
    });

    $('#megamenu-estudios').on('hide.bs.dropdown', function(e) {
      if ( $(this).hasClass('dontClose') ){
        e.preventDefault();
      }else{
        $(this).find('.dropdown-menu').first().stop(true, true).slideUp();
      }
      $(this).removeClass('dontClose');
    });

    $('.js--close').click(function (event) {
      $('header .navbar .dropdown.show .dropdown-toggle').dropdown('toggle');
    });

    /**
      Ocultar el buscador del header al pulsar fuera
     */
    var buscador =$('#buscador-header');

    $(window).click(function (e) {
      if( $(e.target).closest("#buscador-header").length > 0 ) {
        return false;
      }
      else if ($("#buscador-header").is(":visible")){
        buscador.removeClass('open');
      }
    });


    /**
     * Al pulsar la lupa mostramos el desplegable y activamos el focus en el input
     */
    $('.js--dropdown-search i').click(function (event) {
      $('header .dropdown.show .dropdown-toggle').dropdown('toggle');
      //console.log('toggle a todos los dropdowns');
      buscador.addClass('open');
      $('#buscador-header .tab-pane.active input').focus();
      event.stopPropagation();
    });

    $('.dropdown-buscadores .close-buscadores').click(function(){
      buscador.removeClass('open');
    });

    //Si cambiamos de pestaña también activamos el focus en el input
    $('#nav-tab-buscadores a[data-toggle="tab"]').on('shown.bs.tab', function(e){
      $('#buscador-header .tab-pane.active input').focus();
    });


    /**
     * Buscador
     */

    $('.js--icono-toggle').click(function() {
      $('#search-mobile-wrapper').toggleClass('active');
      $('#search-mobile-wrapper.active input').focus();
    });



    /**
     * Pestañas del menu estudio con scroll en versión móvil
     */

    function is_touch_device() {
      // Checks for existence in all browsers and IE10/11 & Surface
      return 'ontouchstart' in window || navigator.maxTouchPoints;
    }


    //inicializar efecto de carga asincrona de imágenes
    window.bLazy = new Blazy({
      success: function(element){
        setTimeout(function(){
          // We want to remove the loader gif now.
          // First we find the parent container
          // then we remove the "loading" class which holds the loader image
          var parent = element.parentNode;
          parent.className = parent.className.replace(/\bloading\b/,'');
        }, 200);
        //console.log("Element loaded: ", element.nodeName);
      }
    });

    //función genérica para recargar todas las imágenes vía Blazy
    function blazyRevalidate(){
      window.bLazy.revalidate();
    }

    /**
     * Botón solicita información en versión móvil
     */
    var lastScrollTop = 0;
    $(window).scroll(function(event){
      if($(window).width() <= 667){
        var st = $(this).scrollTop();
        if (st > lastScrollTop) {
          $('#buttonSoliInfoMobile').css('bottom', '0px');
        } else {
          $('#buttonSoliInfoMobile').css('bottom', '-81px');
        }
        lastScrollTop = st;
      }
    });

    /**
     * Cerrar alerta al abrir menu móvil
     */
    $('#menu-mobile-toggle button').click(function(){
      $('.region-alert-home .alert button').click();
    })

  });


})(jQuery, Drupal);
